import {
  SET_DEPARTURE,
  SET_TOURID,
  SET_PROMO_CODE,
  SET_CITYID,
  SET_PASSENGER_TYPE,
  SET_PROCESSING,
  SET_BOOKING,
  SET_PRICES,
  SET_PASSENGER_DETAILS,
  SET_LOCKOUT,
  SET_TRIPS_PASSENGERS,
  ADD_UPGRADES,
  REMOVE_UPGRADES
  // ,
  // SET_AFFILIATE_APP_ID
} from './types';
import { upgradePayload } from '../helpers/upgradesHelper';

export function SetTourID(tourID){
  return dispatch => dispatch({type:SET_TOURID, payload:{tourID}});
}


export function SetDeparture(date){
  return dispatch => dispatch({type:SET_DEPARTURE, payload:{date}});
}

export function SetPromoCode(promoCode){
  return dispatch => dispatch({type:SET_PROMO_CODE, payload:{promoCode}});
}

export function SetCityID(cityID){
  return dispatch => dispatch({type:SET_CITYID, payload:{cityID}});
}

export function SetPassenger(value){

  let paxArray = [];
  let paxValue = value.Adult;

  for(let i = 0; i < paxValue; i++){
    paxArray.push({"age_category":"Adult"});
  }

  return dispatch => dispatch({type:SET_PASSENGER_TYPE, payload:{paxArray}})
}

export function SetProcessing(value){
  return dispatch => dispatch({type:SET_PROCESSING, payload:value})
}

export function SetBooking(value){
  return dispatch => dispatch({type:SET_BOOKING, payload:value})
}

export function SetPrices(prices){
  return dispatch => dispatch({type:SET_PRICES, payload:{prices}});
}

export function SetPassengerDetails(paxDetails){
  return dispatch => dispatch({type:SET_PASSENGER_DETAILS, payload:paxDetails})
}

export function SetLockout(value){
  return dispatch => dispatch({type:SET_LOCKOUT, payload:value})
}


// export function SetAffilateAppID(value){
//   return dispatch => dispatch({type:SET_AFFILIATE_APP_ID, payload:value})
// }


export function SetTripPassengers(numPax, payload, selectedDate){


  let passengersArray = [];
  let reservationArray = [];
  let counter = 0;

  for(let i = 0; i < payload.length; i++){

    counter++;

    reservationArray.push({
      "date_for": selectedDate,
      "start_city_id":payload[i].start_city_id,
      "end_city_id": payload[i].end_city_id,
      "price":null
    });


    if(counter === payload.length){
      for(let j = 0; j < numPax; j++){
        passengersArray.push({
          "index": j,
          "price": null,
          "reservations":reservationArray
        })
      }
      return dispatch => dispatch({type:SET_TRIPS_PASSENGERS, payload:passengersArray})
    }

  }
}

export function setTripUpgrade(data){

  const _upgradesData = upgradePayload(data);

  if(_upgradesData === undefined) return dispatch => dispatch({type:REMOVE_UPGRADES});

  const payload = {
      "tour_id": _upgradesData.tour_id,
      "city_id": "0",
      "departure_date": _upgradesData.departure_date,
      "promo_code": "",
      "passengers": [],
      "add_ons": []
  }
  return dispatch => dispatch({type:ADD_UPGRADES, payload:payload});


  
}



// WEBPACK FOOTER //
// ./src/actions/currentBooking.js